import { createSelector } from '@reduxjs/toolkit';

import { InsightsState } from 'app-redux/InsightsState';

const slice = (state: InsightsState) => state.diseaseActivityUpdates;
const diseaseActivityDetails = (state: InsightsState) => state.diseaseActivitiesInCountryLocations.disacDetailsData;
const data = (state: InsightsState) => state.diseaseActivityUpdates.data;

const isLoading = (state: InsightsState) => state.diseaseActivityUpdates.isLoading;
const hasError = (state: InsightsState) => state.diseaseActivityUpdates.hasError;
const isLoadingAbove = (state: InsightsState) => state.diseaseActivityUpdates.isLoadingAbove;
const isLoadingBelow = (state: InsightsState) => state.diseaseActivityUpdates.isLoadingBelow;
const filter = (state: InsightsState) => state.diseaseActivityUpdates.filter;

const dailyReports = createSelector(data, x => x?.dailyReports);
const hasNewerEntries = createSelector(data, x => x?.hasNewerEntries);
const hasOlderEntries = createSelector(data, x => x?.hasOlderEntries);
const getTopDescriptionForSelectedUserLocation = createSelector(slice, x => x.topDescriptionForSelectedUserLocation);
const getTopDescriptionForSelectedActivityCountry = createSelector(slice, x => x.topDescriptionForSelectedActivityCountry);

// diseaseActivityUpdatesSelectors
export default {
  isLoading,
  hasError,
  isLoadingAbove,
  isLoadingBelow,
  filter,
  dailyReports,
  hasNewerEntries,
  hasOlderEntries,
  getTopDescriptionForSelectedUserLocation,
  getTopDescriptionForSelectedActivityCountry,
};
